import { EditNote } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { NotificationSound } from '../CommonComponents/CommonNotification'
import { ApiCall, DropDownData } from '../CommonComponents/CustomHooks'

const DealerProfile = () => {
    const [ToggleEdit, setToggleEdit] = useState(false)
    const inputrefs = useRef([])
    const [formData, setFormData] = useState({
        dealerCode: '',
        dealerName: '',
        dealerTypeName: '',
        address: '',
        mobileNo: '',
        emailID: '',
        pincodeNo: '',
        cityName: '',
        stateName: '',
        base64Img: '',
        logoName: '',
        logoExt: ''
    })
    const GeDealerType = DropDownData('GetDealerTypeMaster')

    const GetDealerDetails = async () => {
        const data = {
            Type: 'S'
        }
        let res = await ApiCall(`/api/DealerMaster/FillDealerProfileDetails`, data)
        if (res.status === "SUCCESS") {
            setFormData({
                "dealerCode": res.dealerCode,
                "dealerName": res.dealerName,
                "dealerTypeName": res.dealerTypeName,
                "mobileNo": res.mobileNo,
                "address": res.address,
                "emailID": res.emailID,
                "pincodeNo": res.pincodeNo,
                "cityName": res.cityName,
                "stateName": res.stateName,
                "base64Img": res.base64Img,
                "logoExt": res.logoExt,
                "logoName": res.logoName
            })
        }
        else if (res.status === "ERROR" || res.status === 'UNAUTHORIZED' || res.status === 'EXPIRED') {
            await NotificationSound(res.status, res.message, res.focus, inputrefs);
        }
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                const fileName = file.name;
                const fileExtension = fileName.split('.').pop();
                setFormData(prevFormData => ({
                    ...prevFormData,
                    base64Img: reader.result,
                    logoName: fileName,
                    logoExt: fileExtension,
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                const fileName = file.name;
                const fileExtension = fileName.split('.').pop();
                setFormData(prevFormData => ({
                    ...prevFormData,
                    base64Img: reader.result,
                    logoName: fileName,
                    logoExt: fileExtension,
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
    const UpdateDealerDetails = async () => {
        let data = await ApiCall(`/api/DealerMaster/UpdateDealerProfilePhoto`, { ...formData })
        if (data.status === 'SUCCESS') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs);
            setToggleEdit(false)
        } else if (data.status === 'ERROR') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs);
        }
    }

    useEffect(() => {
        GetDealerDetails()
    }, [])

    return (
        <>
            <div className="row">
                <div className="col-md-12 col-xl-12">
                    <div className="card border-0 " style={{ marginBottom: "16px" }}>
                        <div className="profile_tab" style={{ padding: "19px" }}>
                            <div className='card-headerProfile mb-1 border-bottom d-flex justify-content-between align-items-center' style={{ backgroundColor: "#dbeaff" }}>
                                <h6 className="m-0 p-2" style={{ fontWeight: "bold" }}>  {'Dealer Profile'} </h6>
                                <div style={{ cursor: 'pointer', display: "none" }} onClick={() => setToggleEdit(!ToggleEdit)}>
                                    <span>Edit Info :</span>
                                    <IconButton >
                                        <EditNote />
                                    </IconButton>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 d-flex flex-column align-items-center">
                                    <div>
                                        <div className="mt-3 d-flex justify-content-center">
                                            <img
                                                src={formData.base64Img || './images/avatar.png'}
                                                alt="User Avatar"
                                                style={{
                                                    width: '130px',
                                                    height: '130px',
                                                    borderRadius: '50%',
                                                    marginTop: '5px',
                                                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)'
                                                }}
                                            />
                                        </div>
                                        <div className='photo_uploader w-100 text-center mt-3'
                                            style={{ cursor: 'pointer', border: '2px dashed #ddd', padding: '20px', position: 'relative' }}
                                            onDrop={handleDrop}
                                            onDragOver={handleDragOver}
                                        >
                                            <input
                                                id="file-upload"
                                                className='d-none'
                                                type="file"
                                                name="fileUpload"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                            />
                                            <label htmlFor="file-upload" id="file-drag" style={{ cursor: 'pointer' }}>
                                                <div id="start">
                                                    <i className="fa fa-download fs-4 text-theme mb-2" aria-hidden="true"></i>
                                                    <h6>Upload a Photo</h6>
                                                </div>
                                                <button type="button" name='btn'
                                                    onClick={UpdateDealerDetails}
                                                    className="btn btn-rounded btn-success">
                                                    <span className=" text-white me-2">
                                                        <i className="fa fa-upload color-warning">
                                                        </i>
                                                    </span>Update</button>
                                            </label>
                                            <span className='mt-2 d-block text-secondary'>File Format : png, jpg 200x200</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <div className="tab_body profile_body py-4">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <div className="mb-1">
                                                    <label htmlFor="dealerCode" className="form-label">Dealer Code</label>
                                                    <input
                                                        type="text"
                                                        id="dealerCode"
                                                        className="form-control"
                                                        placeholder="Dealer Code"
                                                        value={formData.dealerCode}
                                                        onChange={(e) => setFormData({ ...formData, dealerCode: e.target.value })}
                                                        disabled={!ToggleEdit}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-1">
                                                    <label htmlFor="dealerName" className="form-label">Dealer Name</label>
                                                    <input
                                                        type="text"
                                                        id="dealerName"
                                                        className="form-control"
                                                        placeholder="Dealer Name"
                                                        value={formData.dealerName}
                                                        onChange={(e) => setFormData({ ...formData, dealerName: e.target.value })}
                                                        disabled={!ToggleEdit}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-1">
                                                    <label htmlFor="dealerTypeName" className="form-label">Dealer Type</label>
                                                    <select
                                                        id="dealerTypeName"
                                                        className="form-control"
                                                        value={formData.dealerTypeName}
                                                        onChange={(e) => setFormData({ ...formData, dealerTypeName: e.target.value })}
                                                        disabled={!ToggleEdit}
                                                    >
                                                        <option value=''>--Please Select--</option>
                                                        {GeDealerType?.data?.dataList?.map((item, index) => (
                                                            <option key={item.name + index} value={item.code}>{item.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-1">
                                                    <label htmlFor="mobileNo" className="form-label">Mobile No</label>
                                                    <input
                                                        type="tel"
                                                        id="mobileNo"
                                                        className="form-control"
                                                        placeholder="Mobile No"
                                                        value={formData.mobileNo}
                                                        onChange={(e) => setFormData({ ...formData, mobileNo: e.target.value })}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-1">
                                                    <label htmlFor="emailID" className="form-label">Email Address</label>
                                                    <input
                                                        type="email"
                                                        id="emailID"
                                                        className="form-control"
                                                        placeholder="Email Address"
                                                        value={formData.emailID}
                                                        onChange={(e) => setFormData({ ...formData, emailID: e.target.value })}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-1">
                                                    <label htmlFor="pincodeNo" className="form-label">Pin Code</label>
                                                    <input
                                                        type="text"
                                                        id="pincodeNo"
                                                        className="form-control"
                                                        placeholder="Pin Code"
                                                        value={formData.pincodeNo}
                                                        onChange={(e) => setFormData({ ...formData, pincodeNo: e.target.value })}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-1">
                                                    <label htmlFor="stateName" className="form-label">State</label>
                                                    <input
                                                        type="text"
                                                        id="stateName"
                                                        className="form-control"
                                                        placeholder="State"
                                                        value={formData.stateName}
                                                        onChange={(e) => setFormData({ ...formData, stateName: e.target.value })}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-1">
                                                    <label htmlFor="cityName" className="form-label">City</label>
                                                    <input
                                                        type="text"
                                                        id="cityName"
                                                        className="form-control"
                                                        placeholder="City"
                                                        value={formData.cityName}
                                                        onChange={(e) => setFormData({ ...formData, cityName: e.target.value })}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-1">
                                                    <label htmlFor="address" className="form-label">Address</label>
                                                    <textarea
                                                        id="address"
                                                        className="form-control"
                                                        placeholder="Address"
                                                        value={formData.address}
                                                        onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                                                        disabled
                                                        rows="3"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default DealerProfile;